import { useContext, useState } from "react"
import React from "react"
import { Outlet, useNavigate } from "react-router-dom"
import { getTable, getAvailableTables } from "../../utils/api-tables"
import { useDispatch } from "react-redux"
import { setIsLoading } from "../../services/reducers/preloader-slice"
import { setTables } from "../../services/reducers/tables-slice"
import { setAuthChecked, setUser } from "../../services/reducers/user-slice"
import { isClickEnter, isUserDelete } from "../reducers/modal-slice"
import { AnalyticsAndNewsDataApi } from "../../utils/api"
import { setObject } from "../../services/reducers/cards-slice"

const ActiveButtonContext = React.createContext()

export const useActiveButton = () => {
  return useContext(ActiveButtonContext)
}

export const ActiveButtonProvider = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [activeButton, setActiveButton] = useState(null)
  const [availableTables, setАvailableTables] = useState([])
  const [tabNumber, setTabNumber] = useState(0)





  const toggle = (num) => {
    setActiveButton(num)
  }
  const logout = () => {
    navigate("/authorization")
    localStorage.removeItem("token")
    localStorage.removeItem("subscription")
    dispatch(setUser(null))
    dispatch(setAuthChecked(false))
    dispatch(isUserDelete(true))
    dispatch(isClickEnter(false))
    // window.location.reload()
  }
  const getAvailableTablesContext = () => {
    if (!!localStorage.getItem("token")) {
      getAvailableTables()
        .then(async (res) => {
          if (res.ok) {
            const data = await res.json()
            // console.log(data)

            setАvailableTables(data.available_tables)
          } else {
            return res.json()
          }
        })
        .then((res) => {
          if (!!res) {
            console.log(res.detail)
          }
          if (!!res && res.detail === "Недопустимый токен.") {
            logout() // Включить для выброса!!!!!!!!!!!!!!!!!
          }
        })
    }
  }
  const CanMightBeInteresting = () => {
    // const getData = () => {
    //   return fetch(`api/analytics-and-news/`)
    //     .then(responseStatus)
    //     .then((res) => {
    //       dispatch(setObject(res.results))
    //     })
    // }
    AnalyticsAndNewsDataApi().then((res) => {
      dispatch(setObject(res.results))
    })
  }
  const getTableFromApi = (sub, slug) => {
    getTable(sub, slug)
      .then(async (res) => {
        const path = {
          404: "/not-found",
          // 401: "/authorization",
          403: "/error-403",
          500: "/error-500",
        }

        if (res.ok) {
          const data = await res.json()
          // console.log(data)
          dispatch(setTables(data))
        } else if (res.status in path) {
          navigate(path[res.status])
        } else {
          return res.json()
        }
      })
      .then((res) => {
        if (!!res) {
          console.log(res.detail)
        }
        if (!!res && res.detail === "Недопустимый токен.") {
          logout() // Включить для выброса!!!!!!!!!!!!!!!!!
        }
      })
      .finally(() => {
        dispatch(setIsLoading(false))
      })
  }
  return (
    <ActiveButtonContext.Provider
      value={{
        visible: activeButton,
        toggle,
        getTableFromApi,
        getAvailableTablesContext,
        availableTables,
        CanMightBeInteresting,
        tabNumber,
        setTabNumber,
      }}
    >
      <Outlet />
    </ActiveButtonContext.Provider>
  )
}
